import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class ClusterDto extends EpimsBaseEntityDto {
	@IsNotEmpty() ClusterId: string;
	@IsNotEmpty() ClusterName: string;
	@IsNotEmpty() ProjectCategoryId: string;
}
